export default "__VITE_ASSET__0f1416c4__"